import { type ReactNode } from 'react';
import { Stack } from '@mui/material';

export const Content = ({ children }: { children: ReactNode }) => {
  return <Stack spacing={0.5}>{children}</Stack>;
};
